import React, { InputHTMLAttributes } from 'react';
import * as Bixby from '$/core';

import './index.scss';

export interface IEmailInputProps {
  domain: string;
  useDatalist?: boolean;
  datasource?: Array<{ id: string }>;
}
const EmailInput: React.FC<IEmailInputProps & InputHTMLAttributes<HTMLInputElement>> = props => {
  const { domain, ...rest } = props;
  // Set domain value once, do not update
  const domainValue = Bixby.Utils.isNullOrEmpty(domain) ? '' : `@${domain}`;

  return (
    <div className="readonly_email">
      <input {...rest} />
      <input className="domain" tabIndex={-1} readOnly value={domainValue} disabled />
    </div>
  );
};

export default EmailInput;
